<template>
  <!-- TODO: Barra a scomparsa per tornare indietro? -->
  <LoadingOverlay :enable="loadingOverlay"/>
  <v-container v-if="parkData !== undefined && maintenanceData === null">
    <v-row no-gutters>
      <v-col class="d-flex justify-center pb-0">
        <img class="w-100" style="max-width: 450px" src="/src/assets/logo_hor_re.png" alt="RossiniEnergy logo"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="text-center">
          <v-card-title>Missing Informations</v-card-title>
          <v-card-text>
            <p>{{ `${t('park')} ${parkData.name} ${t('no_maint_data')}` }}</p>
            <p>{{ t('please_register') }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else v-if="parkData !== undefined && maintenanceData !== undefined">
    <v-row no-gutters>
      <v-col class="d-flex justify-center pb-0">
        <img class="w-100" style="max-width: 450px" src="/src/assets/logo_hor_re.png" alt="RossiniEnergy logo"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title class="text-center">{{ t('maint_exec_meta') }}</v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col md="6" cols="12">
                <v-card class="text-center fill-height" variant="outlined">
                  <v-card-text>
                    <v-text-field
                      readonly
                      :label="t('park_name')"
                      v-model="parkData['name']"
                      variant="underlined"
                      density="compact"
                      hide-details="auto"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="6" cols="12">
                <v-card class="text-center fill-height" variant="outlined">
                  <v-card-text>
                    <v-select
                      :label="t('maint_type')"
                      :items="[{name: t('curative'), id: 'curative'}, {name: t('preventive'), id: 'preventive'}]"
                      item-title="name"
                      item-value="id"
                      v-model="curativePreventiveSelector"
                      multiple
                      variant="underlined"
                      density="compact"
                      hide-details="auto"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="6" cols="12">
                <v-card class="fill-height" variant="outlined">
                  <v-card-text>
                    <v-row>
                      <v-col class="pb-0">
                        <v-dialog width="unset">
                          <template v-slot:activator="{ props: activatorProps}">
                            <v-text-field
                              density="compact" hide-details="auto"
                              clearable persistent-clear :label="t('exec_date')"
                              variant="underlined" readonly v-bind="activatorProps"
                              :model-value="form.execution_date.value.value?.toLocaleDateString('it')"
                              :error-messages="form.execution_date.errorMessage.value"
                            />
                          </template>
                          <template v-slot:default="{ isActive }">
                            <v-card>
                              <v-card-text class="pa-0">
                                <v-date-picker
                                  :title="t('maint_date')"
                                  v-model="form.execution_date.value.value"
                                  :error-messages="form.execution_date.errorMessage.value"
                                  first-day-of-week="1"
                                />
                              </v-card-text>
                              <v-card-actions class="pt-0">
                                <v-spacer></v-spacer>
                                <v-btn
                                  :text="t('close')"
                                  @click="isActive.value = false;console.log(form.execution_date.value.value)"
                                ></v-btn>
                              </v-card-actions>
                            </v-card>
                          </template>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="fill-height" variant="outlined">
                  <v-card-text>
                    <v-autocomplete
                      :label="t('assigned')"
                      :items="technicians"
                      item-title="username"
                      item-value="id"
                      multiple
                      density="compact"
                      variant="underlined"
                      hide-details="auto"
                      v-model="form.technicians.value.value"
                      :error-messages="form.technicians.errorMessage.value"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <v-card class="fill-height" variant="outlined">
                  <v-card-text>
                    <p><b>{{ t('maint_notes') }}</b></p>
                    <p>{{ maintenanceData.notes_maintenance }}</p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="isCurative">
      <v-col>
        <v-card>
          <v-card-title class="text-center">{{ t('curative') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-card class="fill-height">
                  <v-card-title>{{ t('ticket') }}</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col>
                        <v-autocomplete
                          :label="t('ticket_title')"
                          :items="issues"
                          item-title="visual_name"
                          item-value="id"
                          v-model="form.curative.ticket.value.value"
                          :error-messages="form.curative.ticket.errorMessage.value"
                          variant="underlined"
                          hide-details="auto"
                        />
                      </v-col>
                    </v-row>
                    <template v-if="selectedIssue">
                      <v-row>
                        <v-col>
                          <v-textarea
                            :label="t('issue_desc')" variant="outlined" hide-details="auto"
                            density="compact" readonly
                            v-model="selectedIssue['issue_descr']"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-textarea
                            :label="t('resolution_steps')" variant="outlined" hide-details="auto"
                            density="compact" readonly
                            v-model="selectedIssue['how_to_solve_descr']"
                          />
                        </v-col>
                      </v-row>
                    </template>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="fill-height">
                  <v-card-text class="fill-height">
                    <v-textarea
                      class="fill-height"
                      :label="t('things_done')" variant="outlined" hide-details="auto"
                      density="compact"
                      v-model="form.curative.things_done.value.value"
                      :error-messages="form.curative.things_done.errorMessage.value"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="isPreventive">
      <v-col>
        <v-card>
          <v-card-title class="text-center">{{ t('preventive') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" v-if="parkData['has_pilotage']">
                <v-card class="elevation-4 fill-height">
                  <v-card-title>{{ t('pilotage') }}</v-card-title>
                  <v-card-text>
                    <v-text-field
                      :label="t('alim_rpi')"
                      variant="underlined"
                      hide-details="auto"
                      prefix="V"
                      reverse
                      prepend-icon="mdi-lightning-bolt"
                      v-model="form.preventive.pilotage.volt_pc_power_supply.value.value"
                      :error-messages="form.preventive.pilotage.volt_pc_power_supply.errorMessage.value"
                    />
                    <v-checkbox
                      :label="t('rpi_power_supply_grounded')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.pilotage.computer_grounded.value.value"
                      v-if="!maintenanceData.pilotage.computer_grounded"
                    />
                    <v-checkbox
                      :label="t('ensure_neg_not_grounded')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.pilotage.computer_neg_not_grounded.value.value"
                    />
                    <v-checkbox
                      :label="t('replace_teltonika_cable')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.pilotage.replace_teltonika_cable.value.value"
                      v-if="maintenanceData.pilotage.gsm_model === 'teltonika' && !maintenanceData.pilotage.gsm_data['new_teltonika_cable']"
                    />
                    <v-checkbox
                      :label="t('install_C2_on_power_supply')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.pilotage.install_C2_on_pc_power_supply.value.value"
                      v-if="maintenanceData.pilotage.computer_elec_prot !== 'C2'"
                    />
                    <v-checkbox
                      :label="t('replace_sim_card')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.pilotage.install_webbing.value.value"
                      v-if="maintenanceData.pilotage.gsm_data['sim_provider'] !== 'webbing'"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="elevation-4 fill-height">
                  <v-card-title>{{ t('electrical_cabinet') }}</v-card-title>
                  <v-card-text>
                    <v-checkbox
                      :label="t('take_cabinet_photo')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.take_cabinet_photo.value.value"
                    />
                    <v-checkbox
                      :label="t('cabinet_grounded')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.check_grounding_cabinet.value.value"
                    />
                    <v-checkbox
                      :label="t('visual_check_cabinet')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.visual_check_cabinet_tightness.value.value"
                    />
                    <v-checkbox
                      :label="t('check_available_power')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.check_cabinet_voltage.value.value"
                    />
                    <v-checkbox
                      :label="t('grounded_com_braid')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.grounded_com_braid.value.value"
                      v-if="!maintenanceData.grounded_com_braid"
                    />
                    <v-checkbox
                      :label="t('clamping_components')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.check_component_clamping.value.value"
                    />
                    <v-checkbox
                      :label="t('test_differential')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.test_differentials.value.value"
                    />
                    <v-checkbox
                      :label="t('cabinet_sealing')"
                      hide-details="auto"
                      density="compact"
                      v-model="form.preventive.cabinet_sealing.value.value"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="elevation-4 fill-height">
                  <v-card-title>{{ t('voltage_check') }}</v-card-title>
                  <v-card-text>
                    <v-text-field
                      :label="t('phase_neutral')"
                      variant="underlined"
                      hide-details="auto"
                      prefix="V"
                      reverse
                      prepend-icon="mdi-lightning-bolt"
                      v-model="form.preventive.volt_phase_to_neutral.value.value"
                      :error-messages="form.preventive.volt_phase_to_neutral.errorMessage.value"
                    />
                    <v-text-field
                      :label="t('gnd_neutral')"
                      variant="underlined"
                      hide-details="auto"
                      prefix="V"
                      reverse
                      prepend-icon="mdi-lightning-bolt"
                      v-model="form.preventive.volt_gnd_to_neutral.value.value"
                      :error-messages="form.preventive.volt_gnd_to_neutral.errorMessage.value"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="isRetrofit">
              <v-col>
                <v-card class="elevation-4">
                  <v-card-title class="text-center">{{ t('retrofit_park') }}</v-card-title>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col>
                <v-card class="elevation-4">
                  <v-card-title class="text-center">{{ t('per_charging_station') }}</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="6" v-for="(cp, index) in parkData['chargingstations']" :key="cp.bnum">
                        <v-card class="fill-height" elevation="3">
                          <v-card-title>CP {{ cp['park_bnum'] }}</v-card-title>
                          <v-card-text v-if="getMDCP(cp['bnum'])['socket_type'] !== 'disabled'">
                            <v-row no-gutters>
                              <v-col>
                                <v-card variant="outlined">
                                  <v-card-text>
                                    <p><b>{{ t('pole') }}</b></p>
                                    <v-checkbox
                                      :label="t('check_condition')"
                                      hide-details="auto"
                                      density="compact"
                                      v-model="prevCPData[cp['bnum']]['check_pole']"
                                    />
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <v-card variant="outlined">
                                  <v-card-text>
                                    <p><b>{{ t('communication') }}</b></p>
                                    <v-text-field
                                      :label="t('capacity_nF')"
                                      variant="underlined"
                                      prefix="nF"
                                      reverse
                                      v-model="prevCPData[cp['bnum']]['capacity_nF']"
                                      :error-messages="errors[`preventive.cps[${index}].capacity_nF`]"
                                    />
                                    <template v-if="getMDCP(cp['bnum']).communication_cable === 'others'">
                                      <v-checkbox
                                        :label="t('installed_new_cable')"
                                        hide-details="auto"
                                        density="compact"
                                        v-model="prevCPData[cp['bnum']]['installed_new_cable']"
                                      />
                                      <v-expand-transition>
                                        <v-select
                                          v-show="prevCPData[cp['bnum']]['installed_new_cable'] === true"
                                          :label="t('type_new_cable')"
                                          :items="[{name: 'Ethernet', id: 'ethernet'}, {name: 'LIYCY', id: 'LIYCY'}]"
                                          item-title="name"
                                          item-value="id"
                                          variant="underlined"
                                          density="compact"
                                          hide-details="auto"
                                          v-model="prevCPData[cp['bnum']]['new_cable']"
                                        />
                                      </v-expand-transition>
                                    </template>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row no-gutters v-if="getMDCP(cp['bnum'])['socket_type'] === 'with_cable'">
                              <v-col>
                                <v-card variant="outlined">
                                  <v-card-text>
                                    <p><b>{{ t('attached_cable') }}</b></p>
                                    <v-checkbox
                                      :label="t('tighten_base_gun')"
                                      hide-details="auto"
                                      density="compact"
                                      v-model="prevCPData[cp['bnum']]['with_cable']['tightening_gun_base']"
                                    />
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row no-gutters v-if="getMDCP(cp['bnum'])['socket_type'] === 'female'">
                              <v-col>
                                <v-card variant="outlined">
                                  <v-card-text>
                                    <p><b>{{ t('female_outlet') }}</b></p>
                                    <v-checkbox
                                      :label="t('install_blue_solenoid')"
                                      hide-details="auto"
                                      density="compact"
                                      v-model="prevCPData[cp['bnum']]['female_data']['install_blue_solenoid']"
                                      v-if="getMDCP(cp['bnum']).socket_data['solenoid'] !== 'blue'"
                                    />
                                    <v-checkbox
                                      :label="t('tighten_casing_terminal')"
                                      hide-details="auto"
                                      density="compact"
                                      v-model="prevCPData[cp['bnum']]['female_data']['tighten_casing_and_terminal']"
                                    />
                                    <v-checkbox
                                      :label="t('visual_check_seal')"
                                      hide-details="auto"
                                      density="compact"
                                      v-model="prevCPData[cp['bnum']]['female_data']['sealing_housing_visual_test']"
                                    />
                                    <v-checkbox
                                      :label="t('ferrules_6mm2')"
                                      hide-details="auto"
                                      density="compact"
                                      v-model="prevCPData[cp['bnum']]['female_data']['ferrules_6mm2']"
                                      v-if="!getMDCP(cp['bnum']).socket_data['tips_6mm2']"
                                    />
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <v-card variant="outlined">
                                  <v-card-text>
                                    <p><b>{{ t('usage_check') }}</b></p>
                                    <v-checkbox
                                      :label="t('charging_test')"
                                      hide-details="auto"
                                      density="compact"
                                      v-model="prevCPData[cp['bnum']]['charging_test']"
                                    />
                                    <v-checkbox
                                      :label="t('check_charging_measurements')"
                                      hide-details="auto"
                                      density="compact"
                                      v-model="prevCPData[cp['bnum']]['check_measurements']"
                                    />
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-text v-else>
                            DISABLED
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title class="text-center">{{ t('finalization') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-card variant="outlined" class="fill-height">
                  <v-card-title>{{ t('comment') }}</v-card-title>
                  <v-card-text>
                    <v-textarea
                      :label="t('notes_maintenance')"
                      variant="outlined" hide-details="auto"
                      v-model="form.notes.value.value"
                      :error-messages="form.notes.errorMessage.value"
                    />
                    <v-text-field
                      hide-details="auto"
                      clearable persistent-clear :label="t('arrived_at')"
                      variant="underlined" type="time"
                      v-model="form.execution_time.value.value"
                      :error-messages="form.execution_time.errorMessage.value"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card variant="outlined" class="fill-height">
                  <v-card-title>{{ t('customer_signature') }}</v-card-title>
                  <v-card-text>
                    <SignaturePad
                      ref="signatureCanvas"
                      :initial-signature="formState.signature"
                      @endStroke="onSignatureEnd"
                    />
                  </v-card-text>
                  <v-card-actions class="justify-end" v-show="!showMode">
                    <v-btn color="secondary" @click="clearSignature">Clear Signature</v-btn>
                    <v-btn color="primary" variant="elevated" :disabled="loadingOverlay && !snackbar"
                           @click="generalSubmit">Submit
                      All
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <v-snackbar
    v-model="snackbar"
    timer
  >
    {{ snackbarText }}
    <template v-slot:actions>
      <v-btn
        color="gray"
        variant="text"
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { computed, onMounted, ref, shallowRef, watch, reactive } from "vue";
import structuredClone from '@ungap/structured-clone'; // POLYFILL JS < 2022
import * as yup from 'yup';
import { useRoute } from "vue-router";
import { fetchParkById } from "@/remote/park.js";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { fetchMaintenanceData } from "@/remote/maintenancedata.js";
import { useField, useFieldArray, useForm } from "vee-validate";
import { getFormFromSchemaRecursive } from "@/utils.js";
import { fetchUsers } from "@/remote/user.js";
import { fetchParkIssues } from "@/remote/issue.js";
import SignaturePad from "@/components/SignaturePad.vue";
import axios from "axios";
import { endpoint } from "@/remote/utils.js";
import { useI18n } from "vue-i18n";
import { useAuthStore } from "@/store/authstore.js";

const { t } = useI18n({ inheritLocale: true, useScope: 'local' });

const route = useRoute();
const authStore = useAuthStore();
const loadingOverlay = ref(true);
const maintenanceData = shallowRef();
const showMode = ref();
const parkData = shallowRef();
const prevCPData = ref({});
const prevCPDataWatcher = ref(false);
const curativePreventiveSelector = ref([]);
const technicians = shallowRef();
const signatureCanvas = ref();

const snackbar = ref(false);
const snackbarText = ref('');

const issues = shallowRef();
const selectedIssue = computed(() => issues.value.find(el => el['id'] === form.curative.ticket.value.value) || null);

const isCurative = computed(() => curativePreventiveSelector.value.includes('curative'));
const isPreventive = computed(() => curativePreventiveSelector.value.includes('preventive'));
const isRetrofit = computed(() => maintenanceData.value?.electrical_cabinet_type === 'retrofit');

function getMDCP(bnum) {
  return maintenanceData.value['cps'].find((x) => x['chargingstation'] === bnum) || null;
}

// Form
// note: MD fields appear in
//  1. handleSubmit to move data from form values to payload
//  2. in template their relative input can be v-if to hide it
//  3. in case it's v-if in handleSubmit his line is in if
const curativeSchema = yup.object({
  ticket: yup.number().integer().positive().required(),
  things_done: yup.string().required(),
});

const femalePreventiveCPSchema = yup.object({
  install_blue_solenoid: yup.boolean().notRequired().default(false), // MD
  tighten_casing_and_terminal: yup.boolean().required().default(false),
  sealing_housing_visual_test: yup.boolean().required().default(false),
  ferrules_6mm2: yup.boolean().notRequired().default(false), // MD
});

const withCablePreventiveCPSchema = yup.object({
  tightening_gun_base: yup.boolean().required().default(false),
});

const enabledPreventiveCPSchema = yup.object({
  bnum: yup.number().integer().positive().required().default(null),
  female_data: femalePreventiveCPSchema.notRequired().default(() => femalePreventiveCPSchema.getDefault()),
  with_cable: withCablePreventiveCPSchema.notRequired().default(() => withCablePreventiveCPSchema.getDefault()),
  check_pole: yup.boolean().required().default(false),
  capacity_nF: yup.number().positive().required().default(null), // MD
  installed_new_cable: yup.boolean().required().default(false), // MD
  new_cable: yup.string().notRequired().default(null), // MD (useful if installed_new_cable)
  charging_test: yup.boolean().required().default(false),
  check_measurements: yup.boolean().required().default(false),
});

const disabledPreventiveCPSchema = yup.object({
  bnum: yup.number().integer().positive().required().default(null),
}).noUnknown(false);

const preventiveCPSchema = yup.lazy(value => {
  if (maintenanceData.value?.electrical_cabinet_type === 'retrofit') {
    return disabledPreventiveCPSchema;
  }
  if (maintenanceData.value && value && value.bnum) {
    const mdCp = getMDCP(value.bnum);
    if (mdCp && mdCp['socket_type'] === 'disabled') {
      return disabledPreventiveCPSchema;
    }
  }
  return enabledPreventiveCPSchema;
});

const preventivePilotageSchema = yup.object({
  volt_pc_power_supply: yup.number().required(), // MD
  computer_grounded: yup.boolean().notRequired(), // MD
  computer_neg_not_grounded: yup.boolean().required(), // MD
  replace_teltonika_cable: yup.boolean().notRequired(), // MD
  install_C2_on_pc_power_supply: yup.boolean().notRequired(), // MD
  install_webbing: yup.boolean().notRequired(), // MD
});

const preventiveSchema = yup.object({
  cps: yup.array().of(preventiveCPSchema),
  pilotage: preventivePilotageSchema.notRequired(),
  take_cabinet_photo: yup.boolean().required().default(false), // TODO: MISSING (connected to new feature)
  volt_phase_to_neutral: yup.number().required(), // MD
  volt_gnd_to_neutral: yup.number().required(), // MD
  check_grounding_cabinet: yup.boolean().required(),
  grounded_com_braid: yup.boolean().notRequired(), // MD
  check_component_clamping: yup.boolean().required(),
  test_differentials: yup.boolean().required(),
  visual_check_cabinet_tightness: yup.boolean().required(),
  cabinet_sealing: yup.boolean().required(),
  check_cabinet_voltage: yup.boolean().required(),
});

const schema = yup.object({
  curative: curativeSchema.nullable().when([], (_, schema) => isCurative.value ? schema : yup.object({}).notRequired()),
  preventive: preventiveSchema.nullable().when([], (_, schema) => isPreventive.value ? schema : yup.object({}).notRequired()),
  technicians: yup.array().of(yup.number().integer().positive()).min(1).required(),
  notes: yup.string().defined(),
  execution_date: yup.date().required(),
  execution_time: yup.string().required(),
});

const { handleSubmit, errors, validate, values, setValues } = useForm({
  validationSchema: schema
});

const form = getFormFromSchemaRecursive(schema);
form.technicians = useField('technicians', schema);
const {
  push: pcps_push,
  update: pcps_update,
  replace: pcps_replace,
} = useFieldArray('preventive.cps');

const specialFormContext = ref({
  signatureImage: null,
});

async function uploadSignature() {
  try {
    const filebase64 = signatureCanvas.value.getSignature();
    const fileExtension = 'png';
    const payload = {
      image: filebase64,
      file_extension: fileExtension
    };
    return await axios.post(endpoint('internal/current/domaintenancesignatures/'), payload, {
      withCredentials: true
    }).then(response => {
      if (response.status !== 201) {
        snackbarText.value = `Anomalous return code during signature send: ${response.status} ${response.data}`;
        snackbar.value = true;
      }
      return response.data.id;
    }).catch(error => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        snackbarText.value = `Error ${error.response.status}`;
        console.error(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser
        snackbarText.value = `No response received!`;
        console.error(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        snackbarText.value = `Unexpected Error!`;
        console.error(error.message);
      }
      snackbar.value = true;
      return null;
    });
  } catch (e) {
    snackbarText.value = 'Unexpected error during signature send';
    snackbar.value = true;
    console.error(e);
    return null;
  }
}

const submit = handleSubmit(async (values) => {
  console.log("Submit started");
  console.log(values);
  console.log(specialFormContext);
  // execution_time
  const execution_date = values.execution_date;
  const execution_time = values.execution_time.split(':');
  execution_date.setHours(execution_time[0]);
  execution_date.setMinutes(execution_time[1]);
  // prepare maintenance_data copy for payload
  // download them again to be sure to not accidentally rollback changes done in background
  maintenanceData.value = await fetchMaintenanceData(parkData.value['id']);
  const origMd = maintenanceData.value;
  const md = structuredClone(origMd);
  console.log(md);
  // curative
  let curative = null;
  if (isCurative.value) {
    curative = {
      ticket: values.curative.ticket,
      things_done: values.curative.things_done,
    };
  }
  // preventive
  let preventive = null;
  if (isPreventive.value) {
    const cps = [];
    for (const cp of values.preventive.cps) {
      // cp do_maintenance
      const origMdCP = getMDCP(cp['bnum']);
      if (origMdCP === null || isRetrofit.value || origMdCP.socket_type === 'disabled') {
        // No MdCP, or disabled, or retrofit
        cps.push({
          bnum: cp['bnum'],
          tightening_gun_base: null,
          tighten_casing_and_terminal: null,
          sealing_housing_visual_test: null,
        });
        if (origMdCP !== null && !isRetrofit.value) {
          const mdCP = md.cps.find((x) => x['chargingstation'] === cp['bnum']);
          mdCP.capacity_nF = null;
          if (origMdCP.communication_cable === 'others') {
            mdCP.communication_cable = '';
          }
        }
      } else {
        // MdCP present, and type that require data
        const socket_type = origMdCP.socket_type;
        cps.push({
          bnum: cp['bnum'],
          tightening_gun_base: socket_type === 'with_cable' ? cp.with_cable.tightening_gun_base : null,
          tighten_casing_and_terminal: socket_type === 'female' ? cp.female_data.tighten_casing_and_terminal : null,
          sealing_housing_visual_test: socket_type === 'female' ? cp.female_data.sealing_housing_visual_test : null,
        });
        // cp MD delta
        const mdCP = md.cps.find((x) => x['chargingstation'] === cp['bnum']);
        mdCP.capacity_nF = cp.capacity_nF;
        if (origMdCP.communication_cable === 'others')
          mdCP.communication_cable = cp.new_cable;
        // female_data
        if (socket_type === 'female') {
          if (origMdCP.socket_data['solenoid'] !== 'blue' && cp.female_data.install_blue_solenoid)
            mdCP.socket_data['solenoid'] = 'blue';
          if (!origMdCP.socket_data['tips_6mm2'] && cp.female_data.ferrules_6mm2)
            mdCP.socket_data['tips_6mm2'] = true;
        }
      }
    }
    preventive = {
      cps: cps,
      check_cabinet_voltage: values.preventive.check_cabinet_voltage,
      check_grounding_cabinet: values.preventive.check_grounding_cabinet,
      check_component_clamping: values.preventive.check_component_clamping,
      test_differentials: values.preventive.test_differentials,
      visual_check_cabinet_tightness: values.preventive.visual_check_cabinet_tightness,
      cabinet_sealing: values.preventive.cabinet_sealing,
    };
    // MD Deltas
    //   preventive
    md.volt_phase_to_neutral = values.preventive.volt_phase_to_neutral;
    md.volt_gnd_to_neutral = values.preventive.volt_gnd_to_neutral;
    if (!origMd.grounded_com_braid)
      md.grounded_com_braid = values.preventive.grounded_com_braid;
    //   preventive.pilotage
    if (parkData.value['has_pilotage']) {
      if (!origMd.pilotage.computer_grounded)
        md.pilotage.computer_grounded = values.preventive.pilotage.computer_grounded;
      if (origMd.pilotage.gsm_model === 'teltonika' && !origMd.pilotage.gsm_data['new_teltonika_cable'])
        md.pilotage.gsm_data['new_teltonika_cable'] = values.preventive.pilotage.replace_teltonika_cable;
      if (origMd.pilotage.computer_elec_prot !== 'C2' && values.preventive.pilotage.install_C2_on_pc_power_supply)
        md.pilotage.computer_elec_prot = 'C2';
      if (origMd.pilotage.gsm_model !== 'none' && origMd.pilotage.gsm_data['sim_provider'] !== 'webbing'
        && values.preventive.pilotage.install_webbing)
        md.pilotage.gsm_data['sim_provider'] = 'webbing';
    }
  }
  // do_maintenance payload
  const dom_payload = {
    curative: curative,
    preventive: preventive,
    technicians: values.technicians,
    signature: specialFormContext.value.signatureImage,
    execution_time: execution_date.toISOString(),
    notes: values.notes,
  };
  console.log(dom_payload);
  // payload
  const payload = {
    do_maintenance: dom_payload,
    maintenance_data: md,
  };
  // Submit
  try {
    const res = await axios.post(
      endpoint(`internal/current/new_domaintenance/${parkData.value['id']}/`),
      payload,
      { withCredentials: true }
    );
    if (res.status !== 201) {
      snackbarText.value = `Anomalous return code! ${res.status} ${res.data}`;
      snackbar.value = true;
      return false;
    } else {
      snackbarText.value = `Do Maintenance Created with id ${res.data['id']}. The page will reload in a few moments.`;
      if (parkData.value && parkData.value['id']) {
        localStorage.removeItem(`maintenance-form-park-${parkData.value['id']}`);
      }
      snackbar.value = true;
      setTimeout(() => location.reload(), 5000);
      console.log(res.data);
      return true;
    }
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      snackbarText.value = `Error ${e.response.status}`;
      console.error(e.response.data);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      snackbarText.value = `No response received!`;
      console.error(e.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      snackbarText.value = `Unexpected Error!`;
      console.error(e.message);
    }
    snackbar.value = true;
    return false;
  }
});

async function generalSubmit() {
  if (loadingOverlay.value === true) return;
  loadingOverlay.value = true;
  let success = false;
  try {
    // Check if type is selected
    if (!isCurative.value && !isPreventive.value) {
      snackbarText.value = 'Select a maintenance type!';
      snackbar.value = true;
      return;
    }
    // Check if signed
    if (signatureCanvas.value.isEmpty()) {
      snackbarText.value = 'Signature missing';
      snackbar.value = true;
      return;
    }
    // Validate the Form
    const { valid, errors } = await validate();
    if (!valid) {
      console.log("Form validation failed: ", errors);
      snackbarText.value = 'Form not valid';
      snackbar.value = true;
      return;
    }
    // Create SignatureImage
    const signatureId = await uploadSignature();
    console.info(`signatureId ${signatureId}`);
    if (signatureId === undefined || signatureId === null) {
      // Already catched and managed
      return;
    }
    // Generate Extra Post Object Payload
    specialFormContext.value.signatureImage = signatureId;
    success = await submit();
  } catch (e) {
    snackbarText.value = 'Unexpected error during submit send';
    snackbar.value = true;
    console.error(e);
  } finally {
    if (!success) {
      loadingOverlay.value = false;
    }
  }
}

const parkId = computed(() => route.params['parkId']);
const storageKey = computed(() => parkId.value ? `maintenance-form-park-${parkId.value}` : null);

const formState = reactive({
  values: {},
  prevCPData: {},
  curativePreventiveSelector: [],
  signature: null,
});

function onSignatureEnd(signatureData) {
  // console.log('Signature data at stroke end:', signatureData);
  formState.signature = signatureData;
}

function clearSignature() {
  if (signatureCanvas.value) {
    signatureCanvas.value.clearSignature();
  }
  formState.signature = null;
}

watch(formState, (newState) => {
  if (storageKey.value) {
    localStorage.setItem(storageKey.value, JSON.stringify(newState));
  }
}, { deep: true });

watch(curativePreventiveSelector, (newValue, oldValue) => {
  // Setting preventive
  if (newValue.includes('preventive') && !oldValue.includes('preventive')) {
    const new_cps_data = [];
    const new_prevCPData = {};
    for (const [i, cs] of parkData.value['chargingstations'].entries()) {
      const bnum = cs['bnum'];
      const existing_data = prevCPData.value[bnum];
      const d = existing_data ? JSON.parse(JSON.stringify(existing_data)) : enabledPreventiveCPSchema.getDefault();
      d['bnum'] = bnum;
      d['pcps_index'] = i;
      d['capacity_nF'] = maintenanceData.value?.['cps']?.find((v) => v?.['chargingstation'] === bnum)?.['capacity_nF'] ?? null;
      new_cps_data.push(d);
      new_prevCPData[bnum] = d;
    }
    pcps_replace(new_cps_data);
    prevCPData.value = new_prevCPData;
    // Form defaults
    form.preventive.volt_phase_to_neutral.value.value = maintenanceData.value?.['volt_phase_to_neutral'];
    form.preventive.volt_gnd_to_neutral.value.value = maintenanceData.value?.['volt_gnd_to_neutral'];
  }
  // Removing preventive
  if (!newValue.includes('preventive') && oldValue.includes('preventive')) {
    pcps_replace([]);
  }
});

watch(prevCPData, (newValue) => {
  if (prevCPDataWatcher.value) {
    // console.log(newValue);
    for (const key in newValue) {
      const field = newValue[key];
      const { pcps_index, ...data } = field;
      pcps_update(pcps_index, data);
    }
    formState.prevCPData = newValue;
  }
}, { deep: true });

watch(values, (newValues) => {
  formState.values = newValues;
});

watch(curativePreventiveSelector, (newValue) => {
  formState.curativePreventiveSelector = newValue;
}, { deep: true });

// TODO: Add a way to give the ticket directly from the starting url
onMounted(async () => {
  showMode.value = route.meta['show'] || false;
  if (showMode.value) {
    // TODO: Show Mode
  } else {
    // New Mode
    const parkId = route.params['parkId'];
    if (parkId === undefined) {
      alert("Missing Park Input");
      return;
    }
    [
      parkData.value,
      maintenanceData.value,
      technicians.value,
      issues.value,
    ] = await Promise.all([
      fetchParkById(parkId),
      fetchMaintenanceData(parkId),
      fetchUsers('?is_active=1&is_readonly=0&is_staff=1'),
      fetchParkIssues(parkId),
    ]);
    parkData.value['chargingstations'].sort((a, b) => a['park_bnum'] - b['park_bnum']);

    if (storageKey.value) {
      const savedStateJSON = localStorage.getItem(storageKey.value);
      if (savedStateJSON) {
        try {
          const savedState = JSON.parse(savedStateJSON);
          Object.assign(formState, savedState);

          if (formState.values) {
            if (formState.values.execution_date) {
              formState.values.execution_date = new Date(formState.values.execution_date);
            }
            setValues(formState.values);
          }

          // Restore the dynamic form data FIRST
          if (formState.prevCPData) {
            prevCPData.value = formState.prevCPData;
          }

          // THEN restore the selector, which will trigger the watcher
          // that correctly uses the restored prevCPData.
          if (formState.curativePreventiveSelector) {
            curativePreventiveSelector.value = formState.curativePreventiveSelector;
          }

        } catch (e) {
          console.error("Failed to parse or restore saved form state:", e);
          localStorage.removeItem(storageKey.value);
        }
      }
    }

    // add the logged-in user to the technicians array if it's a new form
    if (!formState.values.technicians && authStore.user && authStore.user.id) {
      form.technicians.value.value = [authStore.user.id];
    }
  }
  // console.log("PARK");
  // console.log(parkData.value);
  // console.log("MD");
  // console.log(maintenanceData.value);
  prevCPDataWatcher.value = true;
  loadingOverlay.value = false;
});

</script>

<i18n>
{
  "en": {
    "park": "Park",
    "no_maint_data": "is without maintenance data.",
    "please_register": "Please go into ModifyPark to register the Maintenance Data before starting a maintenance.",
    "maint_exec_meta": "Maintenance Execution Metadata",
    "park_name": "Park Name",
    "maint_type": "Maintenance Type",
    "curative": "Curative",
    "preventive": "Preventive",
    "exec_date": "Execution Date",
    "maint_date": "Maintenance date",
    "close": "Close",
    "assigned": "Assigned",
    "maint_notes": "Maintenance Notes",
    "ticket": "Ticket",
    "ticket_title": "Ticket Title",
    "issue_desc": "Issue description",
    "resolution_steps": "Resolution Steps",
    "things_done": "Things Done",
    "pilotage": "Pilotage",
    "alim_rpi": "Alim RPi [5,10 - 5,20] V DC",
    "rpi_power_supply_grounded": "RPi power supply grounded with 470 Ω",
    "ensure_neg_not_grounded": "Ensure the negative of the power supply is not grounded (470Ω)",
    "replace_teltonika_cable": "Replace Teltonika cable if it's old",
    "install_C2_on_power_supply": "Install a C2 for the 5V power supply",
    "replace_sim_card": "Replace the SIM card if it's an old one",
    "electrical_cabinet": "Electric Cabinet",
    "take_cabinet_photo": "Take a photo of the open cabinet",
    "cabinet_grounded": "Cabinet, rails and metallic door grounded",
    "visual_check_cabinet": "Visual check cabinet components thightness",
    "check_available_power": "Check available power",
    "grounded_com_braid": "Grounded communication braid",
    "clamping_components": "Clamping of components",
    "test_differential": "Test of differential",
    "cabinet_sealing": "Cabinet sealing (add foam if needed)",
    "voltage_check": "Voltage Check",
    "phase_neutral": "Phase-Neutral [230 - 240] V AC",
    "gnd_neutral": "GND-Neutral [0 - 4] V AC",
    "per_charging_station": "Per Charging Station",
    "retrofit_park": "Retrofit Park",
    "pole": "Pole",
    "check_condition": "Check condition (base, cover, stability)",
    "communication": "Communication",
    "capacity_nF": "Capacity in nF",
    "installed_new_cable": "Installed new cable",
    "type_new_cable": "Type of new installed cable",
    "attached_cable": "Attached Cable",
    "tighten_base_gun": "Tighten the base of the gun",
    "female_outlet": "Female Outlet",
    "install_blue_solenoid": "Install blue solenoid",
    "tighten_casing_terminal": "Tighten the casing and terminal blocks",
    "visual_check_seal": "Visual check + seal the casing if needed",
    "ferrules_6mm2": "6mm² ferrules in the female outlet",
    "usage_check": "Usage Check",
    "charging_test": "Charging Test",
    "check_charging_measurements": "Check charging measurements calibration",
    "finalization": "Finalization",
    "comment": "Comment",
    "notes_maintenance": "Notes on Maintenance",
    "arrived_at": "Arrived at",
    "customer_signature": "Customer Signature"
  },
  "it": {
    "park": "Il parco",
    "no_maint_data": "è senza dati di manutenzione.",
    "please_register": "Per favore vai in ModifyPark per registrare i dati di manutenzione prima di iniziare una manutenzione.",
    "maint_exec_meta": "Metadati Esecuzione Manutenzione",
    "park_name": "Nome Parco",
    "maint_type": "Tipo Manutenzione",
    "curative": "Curativa",
    "preventive": "Preventiva",
    "exec_date": "Data Esecuzione",
    "maint_date": "Data manutenzione",
    "close": "Chiudi",
    "assigned": "Assegnati",
    "maint_notes": "Note di Manutenzione",
    "ticket": "Ticket",
    "ticket_title": "Nome Ticket",
    "issue_desc": "Descrizione del problema",
    "resolution_steps": "Passaggi per risoluzione",
    "things_done": "Cose fatte",
    "pilotage": "Pilotaggio",
    "alim_rpi": "Alimentazione RPi [5,10 - 5,20] V DC",
    "rpi_power_supply_grounded": "Alimentazione RPi messa a terra con 470 Ω",
    "ensure_neg_not_grounded": "Assicurarsi che il negativo dell'alimentazione non sia messo a terra (470Ω)",
    "replace_teltonika_cable": "Sostituire il cavo Teltonika se è vecchio",
    "install_C2_on_power_supply": "Installare un C2 per l'alimentazione a 5V",
    "replace_sim_card": "Sostituire la scheda SIM se è vecchia",
    "electrical_cabinet": "Armadio Elettrico",
    "take_cabinet_photo": "Fare una foto dell'armadio aperto",
    "cabinet_grounded": "Armadio, rotaie e porta metallica messi a terra",
    "visual_check_cabinet": "Controllo visivo della tenuta dei componenti dell'armadio",
    "check_available_power": "Controllare potenza disponibile",
    "grounded_com_braid": "Trenza di comunicazione messa a terra",
    "clamping_components": "Morsetti dei componenti",
    "test_differential": "Test differenziale",
    "cabinet_sealing": "Armadio sigillato (aggiungere schiuma se necessario)",
    "voltage_check": "Controllo Tensione",
    "phase_neutral": "Fase-Neutro [230 - 240] V AC",
    "gnd_neutral": "Terra-Neutro [0 - 4] V AC",
    "per_charging_station": "Per Stazione di Ricarica",
    "retrofit_park": "Parco Retrofit",
    "pole": "Palo",
    "check_condition": "Controllare la condizione (base, copertura, stabilità)",
    "communication": "Comunicazione",
    "capacity_nF": "Capacità in nF",
    "installed_new_cable": "Nuovo Cavo Installato",
    "type_new_cable": "Tipo di cavo installato",
    "attached_cable": "Cavo Attaccato",
    "tighten_base_gun": "Stringere la base della pistola",
    "female_outlet": "Presa Femmina",
    "install_blue_solenoid": "Installare il solenoide blu",
    "tighten_casing_terminal": "Stringere il coperchio e i morsetti",
    "visual_check_seal": "Controllo visivo + sigillare il coperchio se necessario",
    "ferrules_6mm2": "Ferrule da 6mm² nella presa femmina",
    "usage_check": "Controllo d'uso",
    "charging_test": "Test di ricarica",
    "check_charging_measurements": "Controllare la calibrazione delle misurazioni di ricarica",
    "finalization": "Finalizzazione",
    "comment": "Commento",
    "notes_maintenance": "Note sulla manutenzione",
    "arrived_at": "Arrivo alle",
    "customer_signature": "Firma del Cliente"
  },
  "fr": {
    "park": "Parc",
    "no_maint_data": "Pas de données de maintenance.",
    "please_register": "Veuiller aller dans ModifyPark pour enregistrer les données de maintenance avant de commencer une maintenance.",
    "maint_exec_meta": "Métadonnées d'exécution de maintenance",
    "park_name": "Nom du parc",
    "maint_type": "Type de maintenance",
    "curative": "Curatif",
    "preventive": "Préventif",
    "exec_date": "Date d'exécution",
    "maint_date": "Date de maintenance",
    "close": "Fermer",
    "assigned": "Assigné",
    "maint_notes": "Notes de maintenance",
    "ticket": "Ticket",
    "ticket_title": "Titre du ticket",
    "issue_desc": "Description du problème",
    "resolution_steps": "Étapes de résolution",
    "things_done": "Choses faites",
    "pilotage": "Pilotage",
    "alim_rpi": "Alim Rpi [5,10 - 5,20] V DC",
    "rpi_power_supply_grounded": "Alimentation Rpi mise à la terre avec 470 Ω",
    "ensure_neg_not_grounded": "Vérifier que le - de l'alimentation n'est pas mis à la terre (470Ω)",
    "replace_teltonika_cable": "Changer le câble Teltonika si c'est un ancien",
    "install_C2_on_power_supply": "Installer un C2 pour l'alimentation 5V",
    "replace_sim_card": "Remplacer la carte SIM si c'est une ancienne",
    "electrical_cabinet": "Armoire électrique",
    "take_cabinet_photo": "Prendre une photo de l'armoire ouverte",
    "cabinet_grounded": "Armoire, rails et porte métallique mis à la terre",
    "visual_check_cabinet": "Vérification visuelle de l'étanchéité de l'armoire",
    "check_available_power": "Vérifier la puissance disponible",
    "grounded_com_braid": "Tresses de communication mise à la terre",
    "clamping_components": "Serrage des composants",
    "test_differential": "Test des différentiels",
    "cabinet_sealing": "Etanchéité de l'armoire (ajouter de la mousse si nécessaire)",
    "voltage_check": "Vérification de la tension",
    "phase_neutral": "Phase-Neutre [230 - 240] V AC",
    "gnd_neutral": "Terra-Neutre [0 - 4] V AC",
    "per_charging_station": "Par Station de Recharge",
    "retrofit_park": "Parc Rénové",
    "pole": "Poteau",
    "check_condition": "Vérifier l'état (base, couvercle, stabilité)",
    "communication": "Communication",
    "capacity_nF": "Capacité en nF",
    "installed_new_cable": "Nouveau câble installé",
    "type_new_cable": "Type de nouveau câble installé",
    "attached_cable": "Câble attaché",
    "tighten_base_gun": "Serrer la base du pistolet",
    "female_outlet": "Prise Femelle",
    "install_blue_solenoid": "Installer le solénoïde bleu",
    "tighten_casing_terminal": "Serrer le boîtier et les bornes",
    "visual_check_seal": "Vérification visuelle + sceller le boîtier si nécessaire",
    "ferrules_6mm2": "Embouts de 6mm² dans la prise femelle",
    "usage_check": "Vérification à l'utilisation",
    "charging_test": "Test de charge",
    "check_charging_measurements": "Vérifier la calibration des pinces de mesures",
    "finalization": "Finalisation",
    "comment": "Commentaire",
    "notes_maintenance": "Notes sur la maintenance",
    "arrived_at": "Arrivé à",
    "customer_signature": "Signature du client"
  }
}
</i18n>


<style scoped>

</style>
